import {getCurrentCompanyId} from './companies';
import {createRepo} from '../services/repo';
const languagesRepo = createRepo({
  modelName: 'language',
  plural: 'languages',
  idKey: 'name',
  isGlobal: true,
  getCurrentCompanyId,
});

const {LANGUAGES_LOADING_SUCCESS} = languagesRepo.actions;
const {handleLanguagesLoading} = languagesRepo.reducers;

const initialState = languagesRepo.getInitialState();

export default function (state = initialState, action) {
  switch (action.type) {
    case LANGUAGES_LOADING_SUCCESS:
      return handleLanguagesLoading(state, action);
    default:
      return state;
  }
}

/* Selectors */

export const {getLanguages} = languagesRepo.selectors;
